// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import ToastService from '../../services/toastService';

// const Login = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [refreshing, setRefreshing] = useState(false);
//   const [pullDistance, setPullDistance] = useState(0);
//   const navigate = useNavigate();
  
//   // Pull to refresh refs
//   const touchStartY = useRef(0);
//   const containerRef = useRef(null);

//   useEffect(() => {
//     // Check if already logged in
//     if (authService.isAuthenticated()) {
//       navigate('/dashboard');
//     }
    
//     // Add toast CSS dynamically
//     if (!document.getElementById('toast-styles')) {
//       const style = document.createElement('style');
//       style.id = 'toast-styles';
//       style.textContent = `
//         .toast-container {
//           position: fixed;
//           z-index: 2000;
//           display: flex;
//           flex-direction: column;
//           gap: 10px;
//           bottom: 20px;
//           right: 50%;
//           transform: translateX(50%);
//           width: 90%;
//           max-width: 350px;
//         }
        
//         .toast {
//           background-color: white;
//           color: #333;
//           padding: 12px 20px;
//           border-radius: 8px;
//           box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
//           opacity: 0;
//           visibility: hidden;
//           transform: translateY(100%);
//           transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
//           font-size: 0.95rem;
//           font-weight: 600;
//           border-left: 5px solid;
//           text-align: center;
//         }
        
//         .toast.show {
//           opacity: 1;
//           visibility: visible;
//           transform: translateY(0);
//         }
        
//         .toast.error { border-left-color: #EF4444; }
//         .toast.info { border-left-color: #1E3A8A; }
//         .toast.success { border-left-color: #10B981; }
//         .toast.warning { border-left-color: #F59E0B; }
        
//         @media (min-width: 601px) {
//           .toast-container {
//             top: 20px;
//             bottom: auto;
//             right: 20px;
//             transform: translateX(0);
//             width: auto;
//             max-width: 400px;
//           }
//           .toast {
//             transform: translateX(100%);
//             text-align: left;
//           }
//           .toast.show {
//             transform: translateX(0);
//           }
//         }
//       `;
//       document.head.appendChild(style);
//     }
//   }, [navigate]);

//   // Pull to Refresh Handlers
//   const handleTouchStart = (e) => {
//     if (containerRef.current && containerRef.current.scrollTop === 0) {
//       touchStartY.current = e.touches[0].clientY;
//     }
//   };

//   const handleTouchMove = (e) => {
//     if (refreshing || loading) return;
    
//     const touchY = e.touches[0].clientY;
//     const pull = touchY - touchStartY.current;
    
//     if (pull > 0 && containerRef.current && containerRef.current.scrollTop === 0) {
//       setPullDistance(Math.min(pull, 100));
//     }
//   };

//   const handleTouchEnd = () => {
//     if (pullDistance > 60) {
//       handleRefresh();
//     }
//     setPullDistance(0);
//   };

//   const handleRefresh = async () => {
//     setRefreshing(true);
    
//     // Simulate refresh - you can add actual refresh logic here
//     setTimeout(() => {
//       setRefreshing(false);
//       ToastService.loginInfo('Page refreshed', 1500);
//     }, 1000);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
    
//     if (!email || !password) {
//       ToastService.loginError('Please enter both email and password');
//       return;
//     }
    
//     if (!/\S+@\S+\.\S+/.test(email)) {
//       ToastService.loginError('Please enter a valid email address');
//       return;
//     }
    
//     setLoading(true);
    
//     try {
//       const result = await authService.login(email, password);
      
//       if (result.success) {
//         ToastService.loginSuccess('Login successful! Redirecting...', 2000);
        
//         setTimeout(() => {
//           navigate('/dashboard');
//         }, 1500);
//       } else {
//         if (result.message && result.message.toLowerCase().includes('invalid')) {
//           ToastService.loginError('Invalid email or password');
//         } else if (result.message && result.message.toLowerCase().includes('account locked')) {
//           ToastService.loginError('Account is locked. Please contact administrator');
//         } else if (result.message && result.message.toLowerCase().includes('inactive')) {
//           ToastService.loginError('Account is inactive. Please contact administrator');
//         } else {
//           ToastService.loginError(result.message || 'Login failed. Please try again.');
//         }
//       }
//     } catch (error) {
//       if (error.message && error.message.includes('Network')) {
//         ToastService.loginError('Network error. Please check your connection');
//       } else if (error.message && error.message.includes('timeout')) {
//         ToastService.loginError('Connection timeout. Please try again');
//       } else if (error.response && error.response.status === 401) {
//         ToastService.loginError('Invalid credentials');
//       } else if (error.response && error.response.status === 403) {
//         ToastService.loginError('Access denied');
//       } else if (error.response && error.response.status === 429) {
//         ToastService.loginError('Too many attempts. Please try again later');
//       } else {
//         ToastService.loginError(error.message || 'Login failed. Please try again.');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleForgotPassword = (e) => {
//     e.preventDefault();
    
//     if (!email) {
//       ToastService.loginInfo('Please enter your email address to receive a reset link.');
//       return;
//     }
    
//     setLoading(true);
//     setTimeout(() => {
//       ToastService.loginSuccess(`A password reset link has been sent to ${email}.`, 5000);
//       setLoading(false);
//     }, 1000);
//   };

//   const togglePasswordVisibility = () => {
//     setShowPassword(!showPassword);
//     if (!showPassword) {
//       ToastService.loginInfo('Password shown', 1500);
//     }
//   };

//   const handleBack = () => {
//     window.history.back();
//   };

//   return (
//     <div 
//       ref={containerRef}
//       className="min-h-screen bg-gradient-to-br from-[#1565ff] to-[#4287ff] flex flex-col items-center justify-center p-4 sm:p-6 md:p-8 lg:p-10 relative overflow-hidden"
//       onTouchStart={handleTouchStart}
//       onTouchMove={handleTouchMove}
//       onTouchEnd={handleTouchEnd}
//     >
//       <div className="toast-container" id="toastContainer"></div>
      
//       {/* Background Decorative Circles */}
//       <div className="absolute w-[180px] h-[180px] sm:w-[220px] sm:h-[220px] md:w-[260px] md:h-[260px] lg:w-[280px] lg:h-[280px] rounded-full bg-white/8 -top-[80px] -left-[60px] sm:-top-[100px] sm:-left-[70px] md:-top-[110px] md:-left-[75px] lg:-top-[120px] lg:-left-[80px]"></div>
//       <div className="absolute w-[140px] h-[140px] sm:w-[170px] sm:h-[170px] md:w-[190px] md:h-[190px] lg:w-[200px] lg:h-[200px] rounded-full bg-white/8 -bottom-[40px] -right-[30px] sm:-bottom-[50px] sm:-right-[35px] md:-bottom-[55px] md:-right-[40px] lg:-bottom-[60px] lg:-right-[40px]"></div>
      
//       {/* Pull to Refresh Indicator */}
//       {pullDistance > 0 && (
//         <div 
//           className="absolute top-0 left-0 right-0 flex items-center justify-center transition-all duration-200 z-10"
//           style={{ 
//             transform: `translateY(${pullDistance}px)`,
//             opacity: pullDistance / 100 
//           }}
//         >
//           <div className={`bg-white rounded-full p-2 shadow-lg ${refreshing ? 'animate-spin' : ''}`}>
//             <svg 
//               className="w-5 h-5 text-[#1565ff]" 
//               fill="none" 
//               stroke="currentColor" 
//               viewBox="0 0 24 24"
//             >
//               <path 
//                 strokeLinecap="round" 
//                 strokeLinejoin="round" 
//                 strokeWidth={2} 
//                 d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
//               />
//             </svg>
//           </div>
//         </div>
//       )}
      
//       {/* Login Card */}
//       <div 
//         className="w-full max-w-[100%] sm:max-w-[420px] md:max-w-[460px] lg:max-w-[480px] xl:max-w-[500px] bg-white rounded-[20px] sm:rounded-[22px] md:rounded-[24px] shadow-[0_10px_40px_rgba(0,0,0,0.15)] md:shadow-[0_20px_60px_rgba(0,0,0,0.15)] p-8 sm:p-10 md:p-12 lg:p-14 relative z-[1] transition-transform duration-200"
//         style={{ 
//           transform: `translateY(${pullDistance * 0.3}px)` 
//         }}
//       >
//         {/* App Logo */}
//         <div className="w-[60px] h-[60px] sm:w-[64px] sm:h-[64px] md:w-[68px] md:h-[68px] lg:w-[72px] lg:h-[72px] bg-gradient-to-br from-[#1565ff] to-[#4287ff] rounded-[16px] md:rounded-[18px] flex items-center justify-center mx-auto mb-6 sm:mb-7 md:mb-8 shadow-[0_6px_20px_rgba(21,101,255,0.3)] md:shadow-[0_8px_24px_rgba(21,101,255,0.3)]">
//           <svg 
//             xmlns="http://www.w3.org/2000/svg" 
//             className="w-[30px] h-[30px] sm:w-[32px] sm:h-[32px] md:w-[34px] md:h-[34px] lg:w-[36px] lg:h-[36px] text-white" 
//             viewBox="0 0 24 24" 
//             fill="none" 
//             stroke="currentColor" 
//             strokeWidth="2" 
//             strokeLinecap="round" 
//             strokeLinejoin="round"
//           >
//             <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
//           </svg>
//         </div>

//         {/* Header */}
//         <div className="text-center mb-6 sm:mb-7 md:mb-8">
//           <h1 className="text-[22px] sm:text-[24px] md:text-[25px] lg:text-[26px] xl:text-[28px] font-semibold text-[#1f2937] mb-1.5 sm:mb-2 tracking-tight">
//             Sales App Lite
//           </h1>
//           <p className="text-[14px] sm:text-[15px] text-[#6b7280]">
//             Enter your details below
//           </p>
//         </div>
        
//         {/* Form */}
//         <form onSubmit={handleSubmit} className="space-y-4 sm:space-y-[18px] md:space-y-5">
//           {/* Email Field */}
//           <div className="relative">
//             <label 
//               htmlFor="email" 
//               className="block text-[13px] sm:text-[14px] font-medium text-[#374151] mb-1.5 sm:mb-2"
//             >
//               Email Address
//             </label>
//             <div className="relative">
//               <span className="absolute left-[14px] sm:left-4 top-1/2 -translate-y-1/2 text-[16px] sm:text-[18px] z-10">
                
//               </span>
//               <input
//                 type="email"
//                 id="email"
//                 className="w-full pl-[40px] sm:pl-[42px] md:pl-[44px] pr-[14px] sm:pr-4 py-3 sm:py-3.5 rounded-[10px] sm:rounded-[11px] md:rounded-xl border border-[#e5e7eb] text-[14px] sm:text-[15px] bg-[#f9fafb] transition-all duration-200 focus:outline-none focus:border-[#1565ff] focus:bg-white focus:shadow-[0_0_0_3px_rgba(21,101,255,0.1)] disabled:opacity-60 disabled:cursor-not-allowed"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Enter your email"
//                 required
//                 disabled={loading}
//                 autoComplete="email"
//               />
//             </div>
//           </div>
          
//           {/* Password Field */}
//           <div className="relative">
//             <label 
//               htmlFor="password" 
//               className="block text-[13px] sm:text-[14px] font-medium text-[#374151] mb-1.5 sm:mb-2"
//             >
//               Password
//             </label>
//             <div className="relative">
//               {/* <span className="absolute left-[14px] sm:left-4 top-1/2 -translate-y-1/2 text-[14px] sm:text-[16px] z-10">
//                 🔒
//               </span> */}
//               <input
//                 type={showPassword ? "text" : "password"}
//                 id="password"
//                 className="w-full pl-[40px] sm:pl-[42px] md:pl-[44px] pr-[50px] sm:pr-[52px] py-3 sm:py-3.5 rounded-[10px] sm:rounded-[11px] md:rounded-xl border border-[#e5e7eb] text-[14px] sm:text-[15px] bg-[#f9fafb] transition-all duration-200 focus:outline-none focus:border-[#1565ff] focus:bg-white focus:shadow-[0_0_0_3px_rgba(21,101,255,0.1)] disabled:opacity-60 disabled:cursor-not-allowed"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Enter your password"
//                 required
//                 disabled={loading}
//                 autoComplete="current-password"
//               />
//               <button
//                 type="button"
//                 className="absolute right-3 sm:right-3.5 top-1/2 -translate-y-1/2 p-2 text-[#9ca3af] hover:text-[#6b7280] active:text-[#6b7280] transition-colors disabled:opacity-60"
//                 onClick={togglePasswordVisibility}
//                 disabled={loading}
//                 aria-label={showPassword ? "Hide password" : "Show password"}
//               >
//                 {showPassword ? (
//                   <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.54 18.54 0 0 1 2.21-3.6"></path>
//                     <path d="M1 1l22 22"></path>
//                     <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"></path>
//                   </svg>
//                 ) : (
//                   <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                     <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
//                     <circle cx="12" cy="12" r="3"></circle>
//                   </svg>
//                 )}
//               </button>
//             </div>
//           </div>

//           {/* Remember Me & Forgot Password */}
//           <div className="flex items-center justify-between text-[14px]">
//             <label className="flex items-center gap-2 cursor-pointer">
//               <input
//                 type="checkbox"
//                 className="w-[18px] h-[18px] cursor-pointer accent-[#1565ff] rounded"
//                 disabled={loading}
//               />
//               <span className="text-[#4b5563] select-none">Remember me</span>
//             </label>
            
//             <a 
//               href="#" 
//               onClick={handleForgotPassword}
//               className="text-[#1565ff] font-medium hover:text-[#0d4fd4] hover:underline transition-colors"
//             >
//               Forgot Password?
//             </a>
//           </div>
          
//           {/* Submit Button */}
//           <button
//             type="submit"
//             className="w-full py-3.5 sm:py-4 rounded-[10px] sm:rounded-[11px] md:rounded-xl bg-gradient-to-r from-[#1565ff] to-[#4287ff] text-white text-[15px] sm:text-[16px] font-semibold shadow-[0_4px_12px_rgba(21,101,255,0.3)] transition-all duration-300 hover:shadow-[0_6px_20px_rgba(21,101,255,0.4)] hover:-translate-y-0.5 active:scale-[0.98] disabled:opacity-60 disabled:cursor-not-allowed disabled:transform-none mt-6 sm:mt-6 relative overflow-hidden"
//             disabled={loading}
//           >
//             {loading && (
//               <span className="absolute inset-0 flex items-center justify-center">
//                 <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                   <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                   <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                 </svg>
//               </span>
//             )}
//             <span className={loading ? 'invisible' : ''}>
//               {loading ? 'Signing In...' : 'Sign In'}
//             </span>
//           </button>
//         </form>

//         {/* Version */}
//         <div className="text-center text-[12px] sm:text-[13px] text-[#9ca3af] mt-5 sm:mt-6">
//           <span>Powered by <a href="www.fidesm.dev" className="text-[#1565ff] font-medium hover:underline">FIDES Management</a></span>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

// import React, { useState, useEffect, useRef } from 'react';
// import { useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import ToastService from '../../services/toastService';

// /* ════════════════════════════════════════════════
//    CSS — Mobile-first, progressively enhanced
// ════════════════════════════════════════════════ */
// const CSS = `
// @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800;900&family=Lora:ital,wght@0,600;0,700&display=swap');

// *, *::before, *::after {
//   box-sizing: border-box;
//   margin: 0; padding: 0;
//   -webkit-tap-highlight-color: transparent;
// }

// :root {
//   --p:      #1A8A6E;
//   --p-dk:   #0f6652;
//   --p-md:   #1d9e7e;
//   --p-lt:   #22c497;
//   --p-xl:   #d9f2ec;
//   --p-xxl:  #eef9f6;
//   --ink:    #071c16;
//   --ink2:   #1a4237;
//   --ink3:   #527d70;
//   --ink4:   #95bdb3;
//   --bdr:    #c0dfd8;
//   --bg:     #ebf8f4;
//   --wh:     #ffffff;
//   --sh:     0 2px 20px rgba(26,138,110,0.10), 0 1px 4px rgba(0,0,0,0.04);
//   --sh-lg:  0 8px 48px rgba(26,138,110,0.14), 0 2px 8px rgba(0,0,0,0.05);
// }

// html { height: -webkit-fill-available; }

// body {
//   min-height: 100vh;
//   min-height: -webkit-fill-available;
//   overscroll-behavior-y: none;
// }

// .lx {
//   min-height: 100dvh;
//   min-height: 100vh;
//   width: 100%;
//   font-family: 'Outfit', sans-serif;
//   -webkit-font-smoothing: antialiased;
//   display: flex;
//   flex-direction: column;
//   background: var(--bg);
//   overflow-x: hidden;
//   position: relative;
// }

// .lx-hero {
//   position: relative;
//   background: linear-gradient(148deg, var(--p-dk) 0%, var(--p) 52%, var(--p-lt) 100%);
//   padding: 54px 22px 0;
//   overflow: hidden;
//   flex-shrink: 0;
// }
// .lx-hero::before,
// .lx-hero::after {
//   content: '';
//   position: absolute;
//   border-radius: 50%;
//   pointer-events: none;
// }
// .lx-hero::before {
//   width: 240px; height: 240px;
//   background: rgba(255,255,255,0.07);
//   top: -85px; right: -55px;
// }
// .lx-hero::after {
//   width: 110px; height: 110px;
//   background: rgba(255,255,255,0.06);
//   top: 18px; left: -32px;
// }

// .lx-brand {
//   display: flex; align-items: center; gap: 10px;
//   position: relative; z-index: 1;
// }
// .lx-brand-icon {
//   width: 38px; height: 38px;
//   background: rgba(255,255,255,0.18);
//   border: 1.5px solid rgba(255,255,255,0.26);
//   border-radius: 11px;
//   display: flex; align-items: center; justify-content: center;
//   flex-shrink: 0;
//   backdrop-filter: blur(8px);
// }
// .lx-brand-name {
//   font-family: 'Lora', serif;
//   font-size: 18px; font-weight: 700;
//   color: #fff; letter-spacing: -0.2px;
// }
// .lx-brand-tag {
//   font-size: 10px; font-weight: 600;
//   color: rgba(255,255,255,0.55);
//   text-transform: uppercase; letter-spacing: 0.8px;
//   background: rgba(255,255,255,0.12);
//   border-radius: 4px; padding: 2px 6px;
//   margin-left: 2px;
// }

// .lx-copy {
//   position: relative; z-index: 1;
//   margin-top: 24px;
// }
// .lx-headline {
//   font-family: 'Lora', serif;
//   font-size: clamp(26px, 7.5vw, 36px);
//   font-weight: 700; color: #fff;
//   line-height: 1.15; letter-spacing: -0.5px;
//   margin-bottom: 10px;
// }
// .lx-subline {
//   font-size: clamp(13px, 3.8vw, 15px);
//   color: rgba(255,255,255,0.68);
//   line-height: 1.6; font-weight: 400;
//   max-width: 340px;
// }

// .lx-live {
//   display: inline-flex; align-items: center; gap: 8px;
//   background: rgba(255,255,255,0.13);
//   border: 1px solid rgba(255,255,255,0.22);
//   border-radius: 40px; padding: 7px 13px;
//   margin-top: 18px; margin-bottom: 28px;
// }
// .lx-live-dot {
//   width: 7px; height: 7px; border-radius: 50%;
//   background: #5fffc8;
//   box-shadow: 0 0 0 3px rgba(95,255,200,0.22);
//   flex-shrink: 0;
//   animation: lxPulse 2.4s ease-in-out infinite;
// }
// @keyframes lxPulse {
//   0%,100% { box-shadow: 0 0 0 3px rgba(95,255,200,0.22); }
//   50%      { box-shadow: 0 0 0 7px rgba(95,255,200,0.06); }
// }
// .lx-live-txt {
//   font-size: 12px; font-weight: 600;
//   color: rgba(255,255,255,0.88);
// }

// .lx-wave-wrap {
//   position: relative;
//   margin-top: 0;
//   line-height: 0;
//   flex-shrink: 0;
//   background: linear-gradient(148deg, var(--p-dk) 0%, var(--p) 52%, var(--p-lt) 100%);
// }
// .lx-wave {
//   display: block; width: 100%;
//   height: 50px;
// }

// .lx-body {
//   flex: 1;
//   display: flex; flex-direction: column;
//   padding: 0 16px 36px;
//   overflow-y: auto;
//   -webkit-overflow-scrolling: touch;
//   background: var(--bg);
// }

// .lx-card {
//   background: var(--wh);
//   border-radius: 24px;
//   padding: 26px 20px 22px;
//   box-shadow:
//     0 -3px 0 0 rgba(26,138,110,0.16) inset,
//     var(--sh-lg);
//   opacity: 0;
//   transform: translateY(24px);
//   transition:
//     opacity 0.44s cubic-bezier(.22,.68,0,1.16),
//     transform 0.44s cubic-bezier(.22,.68,0,1.16);
//   will-change: opacity, transform;
// }
// .lx-card.on {
//   opacity: 1;
//   transform: translateY(0);
// }

// .lx-card-title {
//   font-family: 'Lora', serif;
//   font-size: clamp(20px, 5.5vw, 24px);
//   font-weight: 700; color: var(--ink);
//   letter-spacing: -0.4px; margin-bottom: 4px;
// }
// .lx-card-sub {
//   font-size: 13.5px; color: var(--ink3);
//   margin-bottom: 22px;
// }

// .lx-field { margin-bottom: 16px; }
// .lx-lbl {
//   display: block;
//   font-size: 11.5px; font-weight: 700;
//   color: var(--ink2);
//   text-transform: uppercase; letter-spacing: 0.6px;
//   margin-bottom: 7px;
// }
// .lx-iw { position: relative; }
// .lx-ico {
//   position: absolute;
//   left: 13px; top: 50%;
//   transform: translateY(-50%);
//   color: var(--ink4);
//   display: flex; align-items: center;
//   pointer-events: none;
//   transition: color 0.2s;
// }
// .lx-input {
//   width: 100%;
//   padding: 14px 14px 14px 41px;
//   border-radius: 11px;
//   border: 1.5px solid var(--bdr);
//   background: var(--p-xxl);
//   font-size: clamp(14px, 4vw, 15px);
//   font-family: 'Outfit', sans-serif;
//   color: var(--ink);
//   font-weight: 500;
//   outline: none;
//   -webkit-appearance: none;
//   appearance: none;
//   transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
//   min-height: 52px;
// }
// .lx-input::placeholder { color: var(--ink4); font-weight: 400; }
// .lx-input:focus {
//   border-color: var(--p);
//   background: var(--wh);
//   box-shadow: 0 0 0 3.5px rgba(26,138,110,0.13);
// }
// .lx-iw:focus-within .lx-ico { color: var(--p); }
// .lx-input:disabled { opacity: 0.5; cursor: not-allowed; }
// .lx-input-pr { padding-right: 50px; }

// .lx-eye {
//   position: absolute; right: 8px; top: 50%;
//   transform: translateY(-50%);
//   background: none; border: none;
//   padding: 10px;
//   min-width: 44px; min-height: 44px;
//   display: flex; align-items: center; justify-content: center;
//   cursor: pointer;
//   color: var(--ink4);
//   border-radius: 9px;
//   transition: color 0.15s, background 0.15s;
// }
// .lx-eye:hover { color: var(--p); background: var(--p-xl); }
// .lx-eye:active { background: var(--bdr); }
// .lx-eye:disabled { opacity: 0.4; cursor: not-allowed; }

// .lx-row {
//   display: flex; align-items: center;
//   justify-content: space-between;
//   flex-wrap: wrap; gap: 10px;
//   margin: 4px 0 22px;
// }
// .lx-rem {
//   display: flex; align-items: center; gap: 9px;
//   cursor: pointer; user-select: none;
// }
// .lx-chk {
//   width: 18px; height: 18px;
//   accent-color: var(--p);
//   cursor: pointer; flex-shrink: 0;
// }
// .lx-rem-txt {
//   font-size: clamp(13px, 3.8vw, 14px);
//   color: var(--ink2); font-weight: 500;
// }
// .lx-forgot {
//   font-size: clamp(13px, 3.8vw, 14px);
//   color: var(--p); font-weight: 700;
//   text-decoration: none;
//   transition: color 0.15s;
// }
// .lx-forgot:hover { color: var(--p-dk); text-decoration: underline; }
// .lx-forgot:active { color: var(--p-dk); }

// .lx-btn {
//   width: 100%;
//   min-height: 54px;
//   padding: 15px 20px;
//   border-radius: 12px;
//   border: none; cursor: pointer;
//   background: linear-gradient(130deg, var(--p-dk) 0%, var(--p) 50%, var(--p-lt) 100%);
//   background-size: 200% 100%;
//   background-position: 0% 0%;
//   color: #fff;
//   font-size: clamp(15px, 4.2vw, 16px);
//   font-weight: 700;
//   font-family: 'Outfit', sans-serif;
//   letter-spacing: 0.1px;
//   display: flex; align-items: center; justify-content: center; gap: 8px;
//   box-shadow: 0 4px 20px rgba(26,138,110,0.32);
//   transition: background-position 0.35s, box-shadow 0.25s, transform 0.15s;
//   position: relative; overflow: hidden;
// }
// .lx-btn:hover:not(:disabled) {
//   background-position: 100% 0%;
//   box-shadow: 0 6px 28px rgba(26,138,110,0.40);
//   transform: translateY(-1px);
// }
// .lx-btn:active:not(:disabled) {
//   transform: scale(0.975);
//   box-shadow: 0 2px 10px rgba(26,138,110,0.22);
// }
// .lx-btn:disabled { opacity: 0.60; cursor: not-allowed; transform: none; }

// .lx-div {
//   display: flex; align-items: center; gap: 12px;
//   margin: 20px 0 18px;
// }
// .lx-div-ln { flex: 1; height: 1px; background: var(--bdr); }
// .lx-div-tx {
//   font-size: 12px; color: var(--ink4);
//   font-weight: 500; white-space: nowrap;
//   letter-spacing: 0.3px;
// }

// .lx-sso {
//   width: 100%; min-height: 50px;
//   padding: 13px 16px;
//   border-radius: 12px;
//   border: 1.5px solid var(--bdr);
//   background: var(--wh);
//   color: var(--ink2);
//   font-size: clamp(13.5px, 3.8vw, 14.5px);
//   font-weight: 600;
//   font-family: 'Outfit', sans-serif;
//   cursor: pointer;
//   display: flex; align-items: center; justify-content: center; gap: 10px;
//   transition: border-color 0.2s, background 0.2s, color 0.2s, transform 0.15s;
// }
// .lx-sso:hover { border-color: var(--p); color: var(--p); background: var(--p-xxl); }
// .lx-sso:active { background: var(--p-xl); transform: scale(0.99); }

// .lx-stats {
//   display: flex; align-items: stretch;
//   margin-top: 16px;
//   background: var(--wh);
//   border-radius: 16px;
//   border: 1px solid var(--bdr);
//   overflow: hidden;
//   box-shadow: var(--sh);
// }
// .lx-stat {
//   flex: 1; padding: 14px 8px;
//   text-align: center; position: relative;
// }
// .lx-stat + .lx-stat::before {
//   content: ''; position: absolute;
//   left: 0; top: 18%; bottom: 18%;
//   width: 1px; background: var(--bdr);
// }
// .lx-stat-n {
//   font-family: 'Lora', serif;
//   font-size: clamp(18px, 5vw, 22px);
//   font-weight: 700; color: var(--p);
//   line-height: 1.1;
// }
// .lx-stat-l {
//   font-size: 10px; color: var(--ink3);
//   font-weight: 600; text-transform: uppercase;
//   letter-spacing: 0.5px; margin-top: 4px;
// }

// .lx-foot {
//   text-align: center;
//   font-size: 12px; color: var(--ink4);
//   font-weight: 500; margin-top: 20px;
//   padding-bottom: 4px;
// }
// .lx-foot a { color: var(--p); font-weight: 700; text-decoration: none; }
// .lx-foot a:hover { text-decoration: underline; }

// /* ── Pull-to-refresh indicator ── */
// .lx-ptr {
//   position: fixed; top: 0; left: 0; right: 0;
//   display: flex; justify-content: center; align-items: center;
//   z-index: 300; pointer-events: none;
// }
// .lx-ptr-dot {
//   background: var(--wh); border-radius: 50%;
//   padding: 10px;
//   box-shadow: 0 4px 20px rgba(26,138,110,0.18);
// }
// /* Arrow rotates as user pulls, spins when refreshing */
// .lx-ptr-arrow {
//   transition: transform 0.15s ease;
//   display: flex; align-items: center; justify-content: center;
// }
// .lx-ptr-arrow.ready {
//   transform: rotate(180deg);
// }
// .lx-ptr-arrow.spinning {
//   animation: lxSpin 0.85s linear infinite;
// }

// .lx-spin { animation: lxSpin 0.85s linear infinite; flex-shrink: 0; }
// @keyframes lxSpin { to { transform: rotate(360deg); } }

// .lx-toasts {
//   position: fixed; z-index: 9999;
//   display: flex; flex-direction: column; gap: 9px;
//   bottom: 18px;
//   left: 50%; transform: translateX(-50%);
//   width: calc(100% - 28px); max-width: 380px;
// }
// .toast {
//   background: var(--wh); color: var(--ink);
//   padding: 13px 16px; border-radius: 12px;
//   box-shadow: 0 4px 28px rgba(0,0,0,0.10);
//   opacity: 0; visibility: hidden;
//   transform: translateY(12px) scale(0.96);
//   transition:
//     opacity 0.26s ease,
//     transform 0.26s cubic-bezier(.22,.68,0,1.2),
//     visibility 0.26s;
//   font-size: 14px; font-weight: 600;
//   font-family: 'Outfit', sans-serif;
//   border-left: 4px solid transparent;
// }
// .toast.show {
//   opacity: 1; visibility: visible;
//   transform: translateY(0) scale(1);
// }
// .toast.error   { border-left-color: #EF4444; }
// .toast.info    { border-left-color: var(--p); }
// .toast.success { border-left-color: var(--p-lt); }
// .toast.warning { border-left-color: #F59E0B; }

// /* ════════════════════════════════════════════
//    BREAKPOINTS — mobile-first progressive
// ════════════════════════════════════════════ */
// @media (max-width: 360px) {
//   .lx-hero    { padding: 44px 18px 0; }
//   .lx-headline { font-size: 24px; }
//   .lx-body    { padding: 0 14px 30px; }
//   .lx-card    { padding: 22px 16px 18px; border-radius: 20px; }
//   .lx-btn     { min-height: 50px; }
// }
// @media (min-width: 430px) {
//   .lx-hero  { padding: 56px 28px 0; }
//   .lx-body  { padding: 0 20px 38px; }
//   .lx-card  { padding: 28px 24px 22px; }
//   .lx-headline { font-size: 30px; }
// }
// @media (min-width: 600px) {
//   .lx-hero  { padding: 60px 40px 0; }
//   .lx-body  { padding: 0 28px 44px; max-width: 580px; margin-left: auto; margin-right: auto; width: 100%; }
//   .lx-card  { padding: 34px 30px 28px; border-radius: 26px; }
//   .lx-headline { font-size: 34px; }
//   .lx-toasts {
//     bottom: auto; top: 20px;
//     left: auto; right: 20px;
//     transform: none;
//     width: auto; max-width: 360px;
//   }
//   .toast { transform: translateX(12px) scale(0.96); }
//   .toast.show { transform: translateX(0) scale(1); }
// }
// @media (min-width: 768px) {
//   .lx-hero  { padding: 64px 52px 0; }
//   .lx-headline { font-size: 38px; }
//   .lx-card  { padding: 38px 36px 32px; }
//   .lx-input { min-height: 54px; font-size: 16px; }
//   .lx-btn   { min-height: 56px; font-size: 16px; }
//   .lx-body  { max-width: 640px; }
// }
// @media (min-width: 1024px) {
//   .lx {
//     flex-direction: row;
//     height: 100dvh; height: 100vh;
//     overflow: hidden;
//   }
//   .lx-hero {
//     flex: 1; min-height: 100vh;
//     padding: 56px 60px;
//     display: flex; flex-direction: column;
//     justify-content: space-between;
//     overflow: hidden;
//   }
//   .lx-hero::before { width: 380px; height: 380px; top: -130px; right: -100px; }
//   .lx-hero::after  { width: 200px; height: 200px; top: auto; bottom: -60px; left: -55px; }
//   .lx-copy { padding-bottom: 0; margin-top: 32px; }
//   .lx-headline { font-size: clamp(32px, 3.2vw, 50px); }
//   .lx-subline  { font-size: 16px; max-width: 380px; }
//   .lx-live     { margin-bottom: 0; }
//   .lx-wave-wrap { display: none; }
//   .lx-metrics { display: flex !important; flex-direction: column; gap: 14px; }
//   .lx-body {
//     flex: 0 0 440px; max-width: 440px;
//     padding: 0 44px;
//     overflow-y: auto;
//     display: flex; flex-direction: column; justify-content: center;
//     min-height: 100vh; max-height: 100vh;
//     margin: 0; background: var(--bg);
//   }
//   .lx-card { margin-top: 0; }
// }
// @media (min-width: 1280px) {
//   .lx-body { flex: 0 0 480px; max-width: 480px; padding: 0 52px; }
//   .lx-hero { padding: 60px 72px; }
// }
// @media (min-width: 1440px) {
//   .lx-body { flex: 0 0 520px; max-width: 520px; padding: 0 60px; }
//   .lx-hero { padding: 68px 88px; }
//   .lx-card { padding: 44px 40px 38px; }
//   .lx-headline { font-size: 54px; }
// }

// .lx-metrics { display: none; }
// .lx-mc {
//   background: rgba(255,255,255,0.12);
//   border: 1px solid rgba(255,255,255,0.20);
//   backdrop-filter: blur(16px);
//   -webkit-backdrop-filter: blur(16px);
//   border-radius: 16px; padding: 18px 22px;
// }
// .lx-mc-row { display: flex; gap: 12px; }
// .lx-mc-mini {
//   flex: 1;
//   background: rgba(255,255,255,0.08);
//   border: 1px solid rgba(255,255,255,0.14);
//   backdrop-filter: blur(16px);
//   -webkit-backdrop-filter: blur(16px);
//   border-radius: 12px; padding: 14px 16px;
// }
// .lx-mc-lbl {
//   font-size: 10.5px; text-transform: uppercase;
//   letter-spacing: 0.8px; color: rgba(255,255,255,0.52);
//   margin-bottom: 6px; font-weight: 600;
// }
// .lx-mc-val {
//   font-family: 'Lora', serif;
//   font-size: 26px; font-weight: 700; color: #fff;
//   letter-spacing: -0.3px;
// }
// .lx-mc-mini .lx-mc-val { font-size: 22px; }
// .lx-mc-chg { font-size: 12px; color: #5fffc8; margin-top: 4px; font-weight: 600; }
// .lx-bars {
//   display: flex; align-items: flex-end; gap: 4px;
//   height: 28px; margin-top: 12px;
// }
// .lx-bar {
//   flex: 1; background: rgba(255,255,255,0.28);
//   border-radius: 3px;
//   transition: height 0.5s cubic-bezier(.22,.68,0,1.2);
// }
// `;

// /* ════════════════════════════════════════════════
//    COMPONENT
// ════════════════════════════════════════════════ */
// const Login = () => {
//   const [email,      setEmail]      = useState('');
//   const [password,   setPassword]   = useState('');
//   const [showPw,     setShowPw]     = useState(false);
//   const [loading,    setLoading]    = useState(false);
//   const [refreshing, setRefreshing] = useState(false);
//   const [pull,       setPull]       = useState(0);
//   const [ready,      setReady]      = useState(false);

//   const navigate  = useNavigate();
//   const startY    = useRef(0);
//   const startX    = useRef(0);
//   const bodyRef   = useRef(null);

//   // Guards so only an intentional downward pull from the very top triggers PTR
//   const isPulling    = useRef(false);  // true only after we've committed to a pull gesture
//   const isScrolling  = useRef(false);  // true if we detected horizontal/scroll intent instead
//   const THRESHOLD_PX = 8;             // min vertical px before we commit to pull
//   const HORIZ_LIMIT  = 12;            // if horizontal movement exceeds this first, ignore

//   useEffect(() => {
//     if (!document.getElementById('lx-css')) {
//       const s = document.createElement('style');
//       s.id = 'lx-css'; s.textContent = CSS;
//       document.head.appendChild(s);
//     }
//     if (authService.isAuthenticated()) navigate('/dashboard');
//     const t = setTimeout(() => setReady(true), 60);
//     return () => clearTimeout(t);
//   }, [navigate]);

//   /* ── Pull-to-refresh: intentional only ── */
//   const onTouchStart = e => {
//     // Reset all gesture state on every new touch
//     isPulling.current   = false;
//     isScrolling.current = false;

//     // Only arm PTR when the body scroll is truly at the top
//     if (bodyRef.current?.scrollTop === 0) {
//       startY.current = e.touches[0].clientY;
//       startX.current = e.touches[0].clientX;
//     } else {
//       // Not at top — mark as scrolling so we never trigger PTR this gesture
//       isScrolling.current = true;
//     }
//   };

//   const onTouchMove = e => {
//     // Never trigger if already refreshing, loading, or we decided it's a scroll
//     if (refreshing || loading || isScrolling.current) return;

//     const dy = e.touches[0].clientY - startY.current;
//     const dx = Math.abs(e.touches[0].clientX - startX.current);

//     // If horizontal movement won the race, treat this as a swipe — ignore
//     if (!isPulling.current && dx > HORIZ_LIMIT) {
//       isScrolling.current = true;
//       return;
//     }

//     // Must be a downward pull (dy > 0) and pass the intent threshold before we commit
//     if (!isPulling.current) {
//       if (dy > THRESHOLD_PX) {
//         isPulling.current = true;  // user has genuinely started pulling down
//       } else {
//         return; // not enough movement yet — wait
//       }
//     }

//     // We're in a confirmed pull — update distance (only for downward movement)
//     if (dy > 0) {
//       // Rubber-band feel: resistance increases as pull grows
//       const resistance = dy < 60 ? dy : 60 + (dy - 60) * 0.4;
//       setPull(Math.min(resistance, 88));
//     }
//   };

//   const onTouchEnd = () => {
//     if (!isPulling.current) return; // wasn't a pull gesture at all

//     if (pull > 54 && !refreshing) {
//       setRefreshing(true);
//       setTimeout(() => {
//         setRefreshing(false);
//         ToastService.loginInfo('Page refreshed', 1400);
//       }, 900);
//     }

//     // Always snap back
//     setPull(0);
//     isPulling.current   = false;
//     isScrolling.current = false;
//   };

//   /* ── Submit ── */
//   const handleSubmit = async e => {
//     e.preventDefault();
//     if (!email || !password) {
//       ToastService.loginError('Please enter both email and password'); return;
//     }
//     if (!/\S+@\S+\.\S+/.test(email)) {
//       ToastService.loginError('Please enter a valid email address'); return;
//     }
//     setLoading(true);
//     try {
//       const r = await authService.login(email, password);
//       if (r.success) {
//         ToastService.loginSuccess('Login successful! Redirecting...', 2000);
//         setTimeout(() => navigate('/dashboard'), 1500);
//       } else {
//         const m = (r.message || '').toLowerCase();
//         if (m.includes('invalid'))       ToastService.loginError('Invalid email or password');
//         else if (m.includes('locked'))   ToastService.loginError('Account locked. Contact administrator');
//         else if (m.includes('inactive')) ToastService.loginError('Account inactive. Contact administrator');
//         else ToastService.loginError(r.message || 'Login failed. Please try again.');
//       }
//     } catch (err) {
//       if (err.message?.includes('Network'))      ToastService.loginError('Network error. Check your connection');
//       else if (err.message?.includes('timeout')) ToastService.loginError('Timeout. Please try again');
//       else if (err.response?.status === 401)     ToastService.loginError('Invalid credentials');
//       else if (err.response?.status === 403)     ToastService.loginError('Access denied');
//       else if (err.response?.status === 429)     ToastService.loginError('Too many attempts. Try later');
//       else ToastService.loginError(err.message || 'Login failed. Please try again.');
//     } finally { setLoading(false); }
//   };

//   /* ── Forgot password ── */
//   const handleForgot = e => {
//     e.preventDefault();
//     if (!email) { ToastService.loginInfo('Enter your email first.'); return; }
//     setLoading(true);
//     setTimeout(() => {
//       ToastService.loginSuccess(`Reset link sent to ${email}`, 5000);
//       setLoading(false);
//     }, 1000);
//   };

//   /* ── Toggle password ── */
//   const togglePw = () => {
//     setShowPw(v => !v);
//     if (!showPw) ToastService.loginInfo('Password visible', 1400);
//   };

//   const bars = [34, 50, 40, 74, 57, 90, 66];

//   // Pull indicator: arrow points down → flips up when past threshold → spins when refreshing
//   const pullReady    = pull > 54;
//   const arrowClass   = refreshing ? 'spinning' : pullReady ? 'ready' : '';

//   /* ── Icons ── */
//   const IcMail = () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//       <polyline points="22,6 12,13 2,6"/>
//     </svg>
//   );
//   const IcLock = () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
//       <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
//     </svg>
//   );
//   const IcEyeOn = () => (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
//       <circle cx="12" cy="12" r="3"/>
//     </svg>
//   );
//   const IcEyeOff = () => (
//     <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.54 18.54 0 0 1 2.21-3.6"/>
//       <path d="M1 1l22 22"/>
//       <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
//     </svg>
//   );
//   const IcArrow = () => (
//     <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M5 12h14M12 5l7 7-7 7"/>
//     </svg>
//   );
//   const IcUsers = () => (
//     <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
//       <circle cx="9" cy="7" r="4"/>
//       <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
//       <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
//     </svg>
//   );
//   // Pull arrow icon — points down, flips to up when ready
//   const IcPullArrow = () => (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--p)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M12 5v14M5 12l7 7 7-7"/>
//     </svg>
//   );
//   // Spinner icon used when actively refreshing
//   const IcSpinner = () => (
//     <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--p)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//       <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
//     </svg>
//   );

//   return (
//     <div
//       className="lx"
//       onTouchStart={onTouchStart}
//       onTouchMove={onTouchMove}
//       onTouchEnd={onTouchEnd}
//     >
//       {/* Toast container */}
//       <div id="toastContainer" className="lx-toasts" />

//       {/* Pull-to-refresh indicator — only visible during active intentional pull */}
//       {pull > 0 && (
//         <div
//           className="lx-ptr"
//           style={{
//             transform: `translateY(${pull - 16}px)`,
//             opacity: Math.min(pull / 50, 1),
//           }}
//         >
//           <div className="lx-ptr-dot">
//             <div className={`lx-ptr-arrow ${arrowClass}`}>
//               {refreshing ? <IcSpinner /> : <IcPullArrow />}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ══════════ HERO / LEFT PANEL ══════════ */}
//       <div className="lx-hero">
//         <div className="lx-brand">
//           <div className="lx-brand-icon"><IcUsers /></div>
//           <span className="lx-brand-name">Sales Management</span>
//           <span className="lx-brand-tag">Sales</span>
//         </div>

//         <div className="lx-copy">
//           <div className="lx-headline">SalesHUB Lite<br />Grow faster.</div>
//           <div className="lx-subline">
//             The modern Software for sales teams that move fast and close bigger deals.
//           </div>
//           <div className="lx-live">
//             <div className="lx-live-dot" />
//             <span className="lx-live-txt">384 active deals · $148K revenue MTD</span>
//           </div>
//         </div>

//         {/* Desktop-only metric cards */}
//         <div className="lx-metrics">
//           <div className="lx-mc">
//             <div className="lx-mc-lbl">Revenue this month</div>
//             <div className="lx-mc-val">$148,420</div>
//             <div className="lx-mc-chg">↑ 23.6% vs last month</div>
//             <div className="lx-bars">
//               {bars.map((h, i) => (
//                 <div key={i} className="lx-bar" style={{ height: `${h}%` }} />
//               ))}
//             </div>
//           </div>
//           <div className="lx-mc-row">
//             <div className="lx-mc-mini">
//               <div className="lx-mc-lbl">Active Deals</div>
//               <div className="lx-mc-val">384</div>
//               <div className="lx-mc-chg">↑ 12 today</div>
//             </div>
//             <div className="lx-mc-mini">
//               <div className="lx-mc-lbl">Win Rate</div>
//               <div className="lx-mc-val">67%</div>
//               <div className="lx-mc-chg">↑ 4 pts MoM</div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Wave divider — mobile/tablet only */}
//       <div className="lx-wave-wrap">
//         <svg
//           className="lx-wave"
//           viewBox="0 0 390 50"
//           preserveAspectRatio="none"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path d="M0 50 C80 8, 220 42, 390 8 L390 50 Z" fill="var(--bg)" />
//         </svg>
//       </div>

//       {/* ══════════ FORM / RIGHT PANEL ══════════ */}
//       <div className="lx-body" ref={bodyRef}>
//         <div
//           className={`lx-card ${ready ? 'on' : ''}`}
//           style={{ transform: `translateY(${pull * 0.20}px)` }}
//         >
//           <div className="lx-card-title">Welcome back 👋</div>
//           <div className="lx-card-sub">Sign in to your workspace</div>

//           <form onSubmit={handleSubmit} noValidate>
//             {/* Email */}
//             <div className="lx-field">
//               <label htmlFor="lx-email" className="lx-lbl">Email</label>
//               <div className="lx-iw">
//                 <span className="lx-ico"><IcMail /></span>
//                 <input
//                   id="lx-email" type="email"
//                   className="lx-input"
//                   value={email} onChange={e => setEmail(e.target.value)}
//                   placeholder="you@company.com"
//                   required disabled={loading}
//                   autoComplete="email" inputMode="email"
//                   autoCapitalize="none" autoCorrect="off"
//                 />
//               </div>
//             </div>

//             {/* Password */}
//             <div className="lx-field">
//               <label htmlFor="lx-pass" className="lx-lbl">Password</label>
//               <div className="lx-iw">
//                 <span className="lx-ico"><IcLock /></span>
//                 <input
//                   id="lx-pass"
//                   type={showPw ? 'text' : 'password'}
//                   className="lx-input lx-input-pr"
//                   value={password} onChange={e => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                   required disabled={loading}
//                   autoComplete="current-password"
//                 />
//                 <button
//                   type="button" className="lx-eye"
//                   onClick={togglePw} disabled={loading}
//                   aria-label={showPw ? 'Hide password' : 'Show password'}
//                 >
//                   {showPw ? <IcEyeOff /> : <IcEyeOn />}
//                 </button>
//               </div>
//             </div>

//             {/* Remember / Forgot */}
//             <div className="lx-row">
//               <label className="lx-rem">
//                 <input type="checkbox" className="lx-chk" disabled={loading} />
//                 <span className="lx-rem-txt">Remember me</span>
//               </label>
//               <a href="#" className="lx-forgot" onClick={handleForgot}>
//                 Forgot password?
//               </a>
//             </div>

//             {/* Submit */}
//             <button type="submit" className="lx-btn" disabled={loading}>
//               {loading ? (
//                 <>
//                   <svg className="lx-spin" width="18" height="18" viewBox="0 0 24 24" fill="none">
//                     <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.28)" strokeWidth="4"/>
//                     <path fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
//                   </svg>
//                   Signing in...
//                 </>
//               ) : (
//                 <>Sign In to Workspace <IcArrow /></>
//               )}
//             </button>
//           </form>

//           {/* Divider */}
//           <div className="lx-div">
//             <div className="lx-div-ln" />
//             <span className="lx-div-tx"></span>
//             <div className="lx-div-ln" />
//           </div>

//            {/* Footer */}
//         <div className="lx-foot">
//           Powered by{' '}
//           <a href="https://www.fidesm.dev" target="_blank" rel="noreferrer">
//             FIDES Management
//           </a>
//         </div>
        
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Login;

import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import ToastService from '../../services/toastService';
import { BUSINESS_NAME, VERSION } from '../../utils/config';

/* ══════════════════════════════════════
   INLINE STYLES — Outfit + Lora, #0613cc
══════════════════════════════════════ */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Lora:wght@600;700&display=swap');

*, *::before, *::after {
  box-sizing: border-box; margin: 0; padding: 0;
  -webkit-tap-highlight-color: transparent;
}

:root {
  --p:     #0613cc;
  --p-dk:  #040e99;
  --p-md:  #0a1fe0;
  --p-lt:  #4d6bff;
  --p-xl:  #e8eaff;
  --p-xxl: #f0f1ff;
  --ink:   #060b4d;
  --ink2:  #0e1466;
  --ink3:  #4a4d99;
  --ink4:  #8a8dc9;
  --bdr:   #c8cbf0;
  --bg:    #f5f5ff;
  --wh:    #ffffff;
  --sh:    0 2px 16px rgba(6,19,204,0.08), 0 1px 4px rgba(0,0,0,0.04);
  --sh-lg: 0 8px 40px rgba(6,19,204,0.12), 0 2px 8px rgba(0,0,0,0.05);
}

html { height: -webkit-fill-available; }
body { min-height: 100vh; min-height: -webkit-fill-available; overscroll-behavior-y: none; }

/* ── Root wrapper ── */
.lx {
  min-height: 100dvh; min-height: 100vh;
  width: 100%;
  font-family: 'Outfit', sans-serif;
  -webkit-font-smoothing: antialiased;
  display: flex; flex-direction: column;
  background: var(--bg);
  overflow-x: hidden; position: relative;
}

/* ══════════ HERO / LEFT ══════════ */
.lx-hero {
  position: relative;
  background: var(--p-dk);
  padding: 52px 22px 0;
  overflow: hidden; flex-shrink: 0;
}
/* Subtle geometric accent — no gradient, matches flat SaaS theme */
.lx-hero::before {
  content: '';
  position: absolute;
  width: 260px; height: 260px;
  border: 48px solid rgba(255,255,255,0.05);
  border-radius: 50%;
  top: -80px; right: -70px;
  pointer-events: none;
}
.lx-hero::after {
  content: '';
  position: absolute;
  width: 120px; height: 120px;
  border: 28px solid rgba(255,255,255,0.04);
  border-radius: 50%;
  bottom: 60px; left: -40px;
  pointer-events: none;
}

/* Brand row */
.lx-brand {
  display: flex; align-items: center; gap: 10px;
  position: relative; z-index: 1;
}
.lx-brand-icon {
  width: 38px; height: 38px;
  background: rgba(255,255,255,0.14);
  border: 1.5px solid rgba(255,255,255,0.22);
  border-radius: 11px;
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.lx-brand-name {
  font-family: 'Lora', serif;
  font-size: 17px; font-weight: 700;
  color: #fff; letter-spacing: -0.2px;
}
.lx-brand-tag {
  font-size: 10px; font-weight: 600;
  color: rgba(255,255,255,0.50);
  text-transform: uppercase; letter-spacing: 0.8px;
  background: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.14);
  border-radius: 4px; padding: 2px 7px;
}

/* Copy block */
.lx-copy {
  position: relative; z-index: 1;
  margin-top: 26px;
}
.lx-headline {
  font-family: 'Lora', serif;
  font-size: clamp(24px, 7vw, 34px);
  font-weight: 700; color: #fff;
  line-height: 1.15; letter-spacing: -0.4px;
  margin-bottom: 10px;
}
.lx-subline {
  font-size: clamp(13px, 3.6vw, 14.5px);
  color: rgba(255,255,255,0.60);
  line-height: 1.65; font-weight: 400;
  max-width: 340px;
}

/* Live badge */
.lx-live {
  display: inline-flex; align-items: center; gap: 8px;
  background: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 40px; padding: 7px 14px;
  margin-top: 18px; margin-bottom: 28px;
}
.lx-live-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: var(--p-lt);
  box-shadow: 0 0 0 3px rgba(77,107,255,0.22);
  flex-shrink: 0;
  animation: lxPulse 2.4s ease-in-out infinite;
}
@keyframes lxPulse {
  0%,100% { box-shadow: 0 0 0 3px rgba(77,107,255,0.22); }
  50%      { box-shadow: 0 0 0 8px rgba(77,107,255,0.06); }
}
.lx-live-txt {
  font-size: 12px; font-weight: 600;
  color: rgba(255,255,255,0.80);
}

/* Wave — mobile */
.lx-wave-wrap {
  position: relative; line-height: 0; flex-shrink: 0;
  background: var(--p-dk);
}
.lx-wave { display: block; width: 100%; height: 48px; }

/* ══════════ FORM SIDE ══════════ */
.lx-body {
  flex: 1; display: flex; flex-direction: column;
  padding: 0 16px 36px;
  overflow-y: auto; -webkit-overflow-scrolling: touch;
  background: var(--bg);
}

/* Card */
.lx-card {
  background: var(--wh);
  border-radius: 24px;
  padding: 26px 20px 22px;
  border: 1px solid var(--bdr);
  box-shadow:
    0 -3px 0 0 rgba(6,19,204,0.14) inset,
    var(--sh-lg);
  opacity: 0;
  transform: translateY(22px);
  transition:
    opacity 0.42s cubic-bezier(.22,.68,0,1.16),
    transform 0.42s cubic-bezier(.22,.68,0,1.16);
  will-change: opacity, transform;
}
.lx-card.on { opacity: 1; transform: translateY(0); }

.lx-card-title {
  font-family: 'Lora', serif;
  font-size: clamp(20px, 5.5vw, 24px);
  font-weight: 700; color: var(--ink);
  letter-spacing: -0.4px; margin-bottom: 4px;
}
.lx-card-sub { font-size: 13.5px; color: var(--ink3); margin-bottom: 22px; }

/* Fields */
.lx-field { margin-bottom: 16px; }
.lx-lbl {
  display: block;
  font-size: 11px; font-weight: 700;
  color: var(--ink2); text-transform: uppercase;
  letter-spacing: 0.6px; margin-bottom: 7px;
}
.lx-iw { position: relative; }
.lx-ico {
  position: absolute; left: 13px; top: 50%;
  transform: translateY(-50%); color: var(--ink4);
  display: flex; align-items: center;
  pointer-events: none; transition: color 0.2s;
}
.lx-input {
  width: 100%;
  padding: 13px 14px 13px 41px;
  border-radius: 11px;
  border: 1.5px solid var(--bdr);
  background: var(--p-xxl);
  font-size: clamp(14px, 3.8vw, 15px);
  font-family: 'Outfit', sans-serif;
  color: var(--ink); font-weight: 500;
  outline: none; -webkit-appearance: none; appearance: none;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  min-height: 52px;
}
.lx-input::placeholder { color: var(--ink4); font-weight: 400; }
.lx-input:focus {
  border-color: var(--p);
  background: var(--wh);
  box-shadow: 0 0 0 3.5px rgba(6,19,204,0.11);
}
.lx-iw:focus-within .lx-ico { color: var(--p); }
.lx-input:disabled { opacity: 0.5; cursor: not-allowed; }
.lx-input-pr { padding-right: 50px; }

/* Eye toggle */
.lx-eye {
  position: absolute; right: 8px; top: 50%;
  transform: translateY(-50%);
  background: none; border: none; padding: 10px;
  min-width: 44px; min-height: 44px;
  display: flex; align-items: center; justify-content: center;
  cursor: pointer; color: var(--ink4);
  border-radius: 9px;
  transition: color 0.15s, background 0.15s;
}
.lx-eye:hover { color: var(--p); background: var(--p-xl); }
.lx-eye:active { background: var(--bdr); }
.lx-eye:disabled { opacity: 0.4; cursor: not-allowed; }

/* Remember / forgot row */
.lx-row {
  display: flex; align-items: center;
  justify-content: space-between;
  flex-wrap: wrap; gap: 10px;
  margin: 4px 0 22px;
}
.lx-rem { display: flex; align-items: center; gap: 9px; cursor: pointer; user-select: none; }
.lx-chk { width: 18px; height: 18px; accent-color: var(--p); cursor: pointer; flex-shrink: 0; }
.lx-rem-txt { font-size: clamp(13px, 3.6vw, 14px); color: var(--ink2); font-weight: 500; }
.lx-forgot {
  font-size: clamp(13px, 3.6vw, 14px);
  color: var(--p); font-weight: 700;
  text-decoration: none; transition: color 0.15s;
}
.lx-forgot:hover { color: var(--p-dk); text-decoration: underline; }

/* Submit button — flat solid, no gradient */
.lx-btn {
  width: 100%; min-height: 54px; padding: 15px 20px;
  border-radius: 12px; border: none; cursor: pointer;
  background: var(--p);
  color: #fff;
  font-size: clamp(14.5px, 4vw, 15.5px);
  font-weight: 700; font-family: 'Outfit', sans-serif;
  letter-spacing: 0.1px;
  display: flex; align-items: center; justify-content: center; gap: 8px;
  box-shadow: 0 4px 18px rgba(6,19,204,0.28);
  transition: background 0.2s, box-shadow 0.2s, transform 0.15s;
}
.lx-btn:hover:not(:disabled) {
  background: var(--p-dk);
  box-shadow: 0 6px 26px rgba(6,19,204,0.36);
  transform: translateY(-1px);
}
.lx-btn:active:not(:disabled) { transform: scale(0.975); box-shadow: 0 2px 8px rgba(6,19,204,0.20); }
.lx-btn:disabled { opacity: 0.60; cursor: not-allowed; transform: none; }

/* Divider */
.lx-div { display: flex; align-items: center; gap: 12px; margin: 20px 0 18px; }
.lx-div-ln { flex: 1; height: 1px; background: var(--bdr); }
.lx-div-tx { font-size: 12px; color: var(--ink4); font-weight: 500; white-space: nowrap; }

/* Footer */
.lx-foot {
  text-align: center; font-size: 12px;
  color: var(--ink4); font-weight: 500; margin-top: 20px; padding-bottom: 4px;
}
.lx-foot a { color: var(--p); font-weight: 700; text-decoration: none; }
.lx-foot a:hover { text-decoration: underline; }

/* Pull-to-refresh */
.lx-ptr {
  position: fixed; top: 0; left: 0; right: 0;
  display: flex; justify-content: center; align-items: center;
  z-index: 300; pointer-events: none;
}
.lx-ptr-dot {
  background: var(--wh); border-radius: 50%; padding: 10px;
  box-shadow: 0 4px 18px rgba(6,19,204,0.16);
}
.lx-ptr-arrow { transition: transform 0.15s ease; display: flex; align-items: center; justify-content: center; }
.lx-ptr-arrow.ready { transform: rotate(180deg); }
.lx-ptr-arrow.spinning { animation: lxSpin 0.85s linear infinite; }

.lx-spin { animation: lxSpin 0.85s linear infinite; flex-shrink: 0; }
@keyframes lxSpin { to { transform: rotate(360deg); } }

/* Toasts */
.lx-toasts {
  position: fixed; z-index: 9999;
  display: flex; flex-direction: column; gap: 9px;
  bottom: 18px; left: 50%; transform: translateX(-50%);
  width: calc(100% - 28px); max-width: 380px;
}
.toast {
  background: var(--wh); color: var(--ink);
  padding: 13px 16px; border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  opacity: 0; visibility: hidden;
  transform: translateY(12px) scale(0.96);
  transition: opacity 0.26s ease, transform 0.26s cubic-bezier(.22,.68,0,1.2), visibility 0.26s;
  font-size: 14px; font-weight: 600;
  font-family: 'Outfit', sans-serif;
  border-left: 4px solid transparent;
}
.toast.show { opacity: 1; visibility: visible; transform: translateY(0) scale(1); }
.toast.error   { border-left-color: #EF4444; }
.toast.info    { border-left-color: var(--p); }
.toast.success { border-left-color: var(--p-lt); }
.toast.warning { border-left-color: #F59E0B; }

/* ══════════ RESPONSIVE ══════════ */
@media (max-width: 360px) {
  .lx-hero { padding: 42px 18px 0; }
  .lx-body { padding: 0 14px 30px; }
  .lx-card { padding: 22px 16px 18px; border-radius: 20px; }
  .lx-btn  { min-height: 50px; }
}
@media (min-width: 430px) {
  .lx-hero { padding: 54px 28px 0; }
  .lx-body { padding: 0 20px 38px; }
  .lx-card { padding: 28px 24px 22px; }
}
@media (min-width: 600px) {
  .lx-hero { padding: 58px 40px 0; }
  .lx-body { padding: 0 28px 44px; max-width: 580px; margin: 0 auto; width: 100%; }
  .lx-card { padding: 32px 28px 26px; border-radius: 26px; }
  .lx-toasts { bottom: auto; top: 20px; left: auto; right: 20px; transform: none; width: auto; max-width: 360px; }
  .toast { transform: translateX(12px) scale(0.96); }
  .toast.show { transform: translateX(0) scale(1); }
}
@media (min-width: 768px) {
  .lx-hero { padding: 62px 52px 0; }
  .lx-card { padding: 36px 34px 30px; }
  .lx-input { min-height: 54px; font-size: 15px; }
  .lx-btn  { min-height: 56px; font-size: 15.5px; }
}

/* ── Desktop: side-by-side ── */
@media (min-width: 1024px) {
  .lx { flex-direction: row; height: 100dvh; height: 100vh; overflow: hidden; }

  .lx-hero {
    flex: 1; min-height: 100vh; padding: 56px 60px;
    display: flex; flex-direction: column; justify-content: space-between; overflow: hidden;
  }
  .lx-hero::before { width: 340px; height: 340px; top: -100px; right: -80px; }
  .lx-hero::after  { width: 180px; height: 180px; bottom: -50px; left: -50px; }
  .lx-copy { margin-top: 36px; padding-bottom: 0; }
  .lx-headline { font-size: clamp(30px, 3vw, 48px); }
  .lx-subline  { font-size: 15.5px; max-width: 380px; }
  .lx-live     { margin-bottom: 0; }
  .lx-wave-wrap { display: none; }

  /* Desktop metrics panel */
  .lx-metrics { display: flex !important; flex-direction: column; gap: 14px; }

  .lx-body {
    flex: 0 0 440px; max-width: 440px;
    padding: 0 44px;
    overflow-y: auto;
    display: flex; flex-direction: column; justify-content: center;
    min-height: 100vh; max-height: 100vh;
    margin: 0; background: var(--bg);
  }
  .lx-card { margin-top: 0; }
}
@media (min-width: 1280px) {
  .lx-body { flex: 0 0 480px; max-width: 480px; padding: 0 52px; }
  .lx-hero { padding: 60px 72px; }
}
@media (min-width: 1440px) {
  .lx-body { flex: 0 0 520px; max-width: 520px; padding: 0 60px; }
  .lx-hero { padding: 68px 88px; }
  .lx-card { padding: 42px 38px 36px; }
  .lx-headline { font-size: 52px; }
}

/* ── Desktop metric cards ── */
.lx-metrics { display: none; }
.lx-mc {
  background: rgba(255,255,255,0.10);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: 16px; padding: 18px 22px;
}
.lx-mc-row { display: flex; gap: 12px; }
.lx-mc-mini {
  flex: 1;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 12px; padding: 14px 16px;
}
.lx-mc-lbl {
  font-size: 10.5px; text-transform: uppercase;
  letter-spacing: 0.8px; color: rgba(255,255,255,0.48);
  margin-bottom: 6px; font-weight: 600;
}
.lx-mc-val {
  font-family: 'Lora', serif;
  font-size: 26px; font-weight: 700; color: #fff; letter-spacing: -0.3px;
}
.lx-mc-mini .lx-mc-val { font-size: 22px; }
.lx-mc-chg { font-size: 12px; color: var(--p-lt); margin-top: 4px; font-weight: 600; }
.lx-bars { display: flex; align-items: flex-end; gap: 4px; height: 28px; margin-top: 12px; }
.lx-bar {
  flex: 1; background: rgba(255,255,255,0.22);
  border-radius: 3px;
  transition: height 0.5s cubic-bezier(.22,.68,0,1.2);
}
`;

/* ══════════════════════════════════════
   COMPONENT
══════════════════════════════════════ */
const Login = () => {
  /* ── All original state — untouched ── */
  const [email,      setEmail]      = useState('');
  const [password,   setPassword]   = useState('');
  const [showPw,     setShowPw]     = useState(false);
  const [loading,    setLoading]    = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [pull,       setPull]       = useState(0);
  const [ready,      setReady]      = useState(false);

  const navigate = useNavigate();
  const startY   = useRef(0);
  const startX   = useRef(0);
  const bodyRef  = useRef(null);

  const isPulling   = useRef(false);
  const isScrolling = useRef(false);
  const THRESHOLD_PX = 8;
  const HORIZ_LIMIT  = 12;

  useEffect(() => {
    if (!document.getElementById('lx-css')) {
      const s = document.createElement('style');
      s.id = 'lx-css'; s.textContent = CSS;
      document.head.appendChild(s);
    }
    if (authService.isAuthenticated()) navigate('/dashboard');
    const t = setTimeout(() => setReady(true), 60);
    return () => clearTimeout(t);
  }, [navigate]);

  /* ── Pull-to-refresh — original logic ── */
  const onTouchStart = e => {
    isPulling.current   = false;
    isScrolling.current = false;
    if (bodyRef.current?.scrollTop === 0) {
      startY.current = e.touches[0].clientY;
      startX.current = e.touches[0].clientX;
    } else {
      isScrolling.current = true;
    }
  };

  const onTouchMove = e => {
    if (refreshing || loading || isScrolling.current) return;
    const dy = e.touches[0].clientY - startY.current;
    const dx = Math.abs(e.touches[0].clientX - startX.current);
    if (!isPulling.current && dx > HORIZ_LIMIT) { isScrolling.current = true; return; }
    if (!isPulling.current) {
      if (dy > THRESHOLD_PX) { isPulling.current = true; } else { return; }
    }
    if (dy > 0) {
      const resistance = dy < 60 ? dy : 60 + (dy - 60) * 0.4;
      setPull(Math.min(resistance, 88));
    }
  };

  const onTouchEnd = () => {
    if (!isPulling.current) return;
    if (pull > 54 && !refreshing) {
      setRefreshing(true);
      setTimeout(() => {
        setRefreshing(false);
        ToastService.loginInfo('Page refreshed', 1400);
      }, 900);
    }
    setPull(0);
    isPulling.current   = false;
    isScrolling.current = false;
  };

  /* ── Submit — original logic ── */
  const handleSubmit = async e => {
    e.preventDefault();
    if (!email || !password) {
      ToastService.loginError('Please enter both email and password'); return;
    }
    if (!/\S+@\S+\.\S+/.test(email)) {
      ToastService.loginError('Please enter a valid email address'); return;
    }
    setLoading(true);
    try {
      const r = await authService.login(email, password);
      if (r.success) {
        ToastService.loginSuccess('Login successful! Redirecting...', 2000);
        setTimeout(() => navigate('/dashboard'), 1500);
      } else {
        const m = (r.message || '').toLowerCase();
        if (m.includes('invalid'))       ToastService.loginError('Invalid email or password');
        else if (m.includes('locked'))   ToastService.loginError('Account locked. Contact administrator');
        else if (m.includes('inactive')) ToastService.loginError('Account inactive. Contact administrator');
        else ToastService.loginError(r.message || 'Login failed. Please try again.');
      }
    } catch (err) {
      if (err.message?.includes('Network'))      ToastService.loginError('Network error. Check your connection');
      else if (err.message?.includes('timeout')) ToastService.loginError('Timeout. Please try again');
      else if (err.response?.status === 401)     ToastService.loginError('Invalid credentials');
      else if (err.response?.status === 403)     ToastService.loginError('Access denied');
      else if (err.response?.status === 429)     ToastService.loginError('Too many attempts. Try later');
      else ToastService.loginError(err.message || 'Login failed. Please try again.');
    } finally { setLoading(false); }
  };

  /* ── Forgot — original logic ── */
  const handleForgot = e => {
    e.preventDefault();
    if (!email) { ToastService.loginInfo('Enter your email first.'); return; }
    setLoading(true);
    setTimeout(() => {
      ToastService.loginSuccess(`Reset link sent to ${email}`, 5000);
      setLoading(false);
    }, 1000);
  };

  /* ── Toggle password — original logic ── */
  const togglePw = () => {
    setShowPw(v => !v);
    if (!showPw) ToastService.loginInfo('Password visible', 1400);
  };

  const bars = [34, 50, 40, 74, 57, 90, 66];
  const pullReady  = pull > 54;
  const arrowClass = refreshing ? 'spinning' : pullReady ? 'ready' : '';

  /* ── Icons ── */
  const IcMail = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
      <polyline points="22,6 12,13 2,6"/>
    </svg>
  );
  const IcLock = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  );
  const IcEyeOn = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );
  const IcEyeOff = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.54 18.54 0 0 1 2.21-3.6"/>
      <path d="M1 1l22 22"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
    </svg>
  );
  const IcArrow = () => (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  );
  const IcUsers = () => (
    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  );
  const IcPullArrow = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--p)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 5v14M5 12l7 7 7-7"/>
    </svg>
  );
  const IcSpinner = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--p)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"/>
    </svg>
  );

  return (
    <div
      className="lx"
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
    >
      {/* Toast container */}
      <div id="toastContainer" className="lx-toasts" />

      {/* Pull-to-refresh indicator */}
      {pull > 0 && (
        <div
          className="lx-ptr"
          style={{ transform: `translateY(${pull - 16}px)`, opacity: Math.min(pull / 50, 1) }}
        >
          <div className="lx-ptr-dot">
            <div className={`lx-ptr-arrow ${arrowClass}`}>
              {refreshing ? <IcSpinner /> : <IcPullArrow />}
            </div>
          </div>
        </div>
      )}

      {/* ══════════ HERO / LEFT PANEL ══════════ */}
      <div className="lx-hero">
        {/* <div className="lx-brand">
          <div className="lx-brand-icon"><IcUsers /></div>
          <span className="lx-brand-name">Sales Management</span>
          <span className="lx-brand-tag">Sales</span>
        </div> */}

        <div className="lx-copy">
          <div className="lx-headline">{BUSINESS_NAME}<br />Grow faster.</div>
          <div className="lx-subline">
            The modern software for sales teams that move fast and close bigger deals.
          </div>
          <div className="lx-live">
            <div className="lx-live-dot" />
            <span className="lx-live-txt">More Faster More Sales</span>
          </div>
        </div>

        {/* Desktop-only metric cards */}
        {/* <div className="lx-metrics">
          <div className="lx-mc">
            <div className="lx-mc-lbl">Revenue this month</div>
            <div className="lx-mc-val">$148,420</div>
            <div className="lx-mc-chg">↑ 23.6% vs last month</div>
            <div className="lx-bars">
              {bars.map((h, i) => (
                <div key={i} className="lx-bar" style={{ height: `${h}%` }} />
              ))}
            </div>
          </div>
          <div className="lx-mc-row">
            <div className="lx-mc-mini">
              <div className="lx-mc-lbl">Active Deals</div>
              <div className="lx-mc-val">384</div>
              <div className="lx-mc-chg">↑ 12 today</div>
            </div>
            <div className="lx-mc-mini">
              <div className="lx-mc-lbl">Win Rate</div>
              <div className="lx-mc-val">67%</div>
              <div className="lx-mc-chg">↑ 4 pts MoM</div>
            </div>
          </div>
        </div> */}
      </div>

      {/* Wave divider — mobile/tablet only */}
      <div className="lx-wave-wrap">
        <svg
          className="lx-wave"
          viewBox="0 0 390 48"
          preserveAspectRatio="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 48 C80 8, 220 40, 390 8 L390 48 Z" fill="var(--bg)" />
        </svg>
      </div>

      {/* ══════════ FORM / RIGHT PANEL ══════════ */}
      <div className="lx-body" ref={bodyRef}>
        <div
          className={`lx-card ${ready ? 'on' : ''}`}
          style={{ transform: `translateY(${pull * 0.20}px)` }}
        >
          <div className="lx-card-title">Welcome back</div>
          <div className="lx-card-sub">Sign in to your workspace</div>

          <form onSubmit={handleSubmit} noValidate>
            {/* Email */}
            <div className="lx-field">
              <label htmlFor="lx-email" className="lx-lbl">Email</label>
              <div className="lx-iw">
                <span className="lx-ico"><IcMail /></span>
                <input
                  id="lx-email" type="email"
                  className="lx-input"
                  value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  required disabled={loading}
                  autoComplete="email" inputMode="email"
                  autoCapitalize="none" autoCorrect="off"
                />
              </div>
            </div>

            {/* Password */}
            <div className="lx-field">
              <label htmlFor="lx-pass" className="lx-lbl">Password</label>
              <div className="lx-iw">
                <span className="lx-ico"><IcLock /></span>
                <input
                  id="lx-pass"
                  type={showPw ? 'text' : 'password'}
                  className="lx-input lx-input-pr"
                  value={password} onChange={e => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button" className="lx-eye"
                  onClick={togglePw} disabled={loading}
                  aria-label={showPw ? 'Hide password' : 'Show password'}
                >
                  {showPw ? <IcEyeOff /> : <IcEyeOn />}
                </button>
              </div>
            </div>

            {/* Remember / Forgot */}
            <div className="lx-row">
              <label className="lx-rem">
                <input type="checkbox" className="lx-chk" disabled={loading} />
                <span className="lx-rem-txt">Remember me</span>
              </label>
              <a href="#" className="lx-forgot" onClick={handleForgot}>
                Forgot password?
              </a>
            </div>

            {/* Submit */}
            <button type="submit" className="lx-btn" disabled={loading}>
              {loading ? (
                <>
                  <svg className="lx-spin" width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.28)" strokeWidth="4"/>
                    <path fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
                  </svg>
                  Signing in...
                </>
              ) : (
                <>Sign In to Workspace <IcArrow /></>
              )}
            </button>
          </form>

          {/* Divider */}
          <div className="lx-div">
            <div className="lx-div-ln" />
            <span className="lx-div-tx"></span>
            <div className="lx-div-ln" />
          </div>

          {/* Footer */}
          <div className="lx-foot">
            Powered by{' '}
            <a href="https://www.fidesm.dev" target="_blank" rel="noreferrer">
              FIDES Management
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;